export default __webpack_public_path__ + "static/project-slide-3-415-700-dfd83711c124ee85decb3133d7d65662.jpg";